import { useState } from "react";
import PropTypes from "prop-types";
import { Text, CloseButton, Button } from "@react-spectrum/s2";
import InfoIcon from "@spectrum-icons/workflow/Info";
import AlertIcon from "@spectrum-icons/workflow/Alert";
import CheckmarkIcon from "@spectrum-icons/workflow/Checkmark";
import AlertDiamondIcon from "@react-spectrum/s2/icons/AlertDiamond";

import {
  style,
  focusRing,
} from "@react-spectrum/s2/style" with { type: "macro" };

const alertStyle = style({
  ...focusRing(),
  outlineColor: {
    default: "focus-ring",
    // isExpanded: 'white'
  },
  display: "flex",
  gap: 16,
  paddingStart: 16,
  paddingEnd: 8,
  paddingY: 12,
  // borderRadius: "lg",
  minHeight: 56,
  // "--maxWidth": {
  //   type: "maxWidth",
  //   value: 336,
  // },
  // maxWidth: "min(var(--maxWidth), 90vw)",
  boxSizing: "border-box",
  flexShrink: 0,
  font: "ui",
  color: "heading",
  backgroundColor: {
    variant: {
      neutral: "neutral-subtle",
      info: "informative-subtle",
      positive: "positive-subtle",
      negative: "negative-subtle",
      notice: "notice-subtle",
    },
  },
  "--iconPrimary": {
    type: "fill",
    value: "currentColor",
  },
  boxShadow: {
    default: "elevated",
    // isExpanded: 'none'
  },
  willChange: "transform",
});

const alertBody = style({
  // The top toast in a non-expanded stack has the expand button, so it is rendered as a grid.
  // Otherwise it uses flex so the content can wrap when needed.
  display: "flex",
  flexGrow: 1,
  flexWrap: "wrap",
  alignItems: "center",
  columnGap: 24,
  rowGap: 8,
});

const alertContent = style({
  display: "flex",
  flexGrow: 1,
  gap: 8,
  alignItems: "center",
  gridArea: "content",
  cursor: "default",
  width: "fit",
  overflowWrap: "break-word",
  wordBreak: "break-word",
  minWidth: 0,
});

const controls = style({
  colorScheme: "light",
  display: {
    default: "none",
    isExpanded: "flex",
  },
  justifyContent: "end",
  gap: 8,
  opacity: {
    default: 0,
    isExpanded: 1,
  },
});

const ICONS = {
  info: InfoIcon,
  negative: AlertIcon,
  positive: CheckmarkIcon,
  notice: AlertDiamondIcon,
};

export const AlertBanner = ({
  variant = "info",
  children,
  actionLabel,
  onAction,
  shouldCloseOnAction,
  styles = "",
}) => {
  const [isClosed, setClosed] = useState(false);
  const Icon = ICONS[variant];

  if (isClosed) {
    return null;
  }

  return (
    <div className={alertStyle({ variant }) + styles}>
      <div className={alertBody}>
        <div className={alertContent}>
          {Icon && (
            <div
              className={style({
                flexBasis: 20,
              })}
            >
              <Icon UNSAFE_className={style({ size: 20 })} />
            </div>
          )}
          <Text slot="title">{children}</Text>
        </div>
        {actionLabel && (
          <Button
            variant="secondary"
            fillStyle="outline"
            staticColor="white"
            onPress={() => {
              onAction?.();
              if (shouldCloseOnAction) {
                // state.close(toast.key);
              }
            }}
            // UNSAFE_className={ctx && isMain ? toastCss['toast-action'] : undefined}
            styles={style({ marginStart: "auto", gridArea: "action" })}
          >
            <Text>{actionLabel}</Text>
          </Button>
        )}
      </div>
      <CloseButton onPress={() => setClosed(true)} />
    </div>
  );
};

AlertBanner.propTypes = {
  variant: PropTypes.oneOf([
    "positive",
    "negative",
    "notice",
    "info",
    "neutral",
  ]).isRequired,
  children: PropTypes.node.isRequired,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  shouldCloseOnAction: PropTypes.bool,
  styles: PropTypes.string,
};
